<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="openAddDialog('cashback')"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                  />
                </svg>
              </v-btn>
              <span>Add Cashback</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>

            <!-- Dialog for Add View Edit -->
            <action-dialog
              :type="dialogType"
              :title="dialogTitle"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs fluid>
                <details-container
                  v-if="dialogType === 'view'"
                  ref="detailsRef"
                  :data="viewData"
                  :readonly="dialogType === 'view'"
                  @openMap="openMap($event)"
                />
          
                <v-layout v-if="dialogTitle === 'cashback'" justify-center>
                  <v-flex md6>
                    <jti-expansion-panel panelName="Cashback Details">
                      <v-form v-model="valid" ref="form" lazy-validation>
                        <v-container grid-list-lg>
                          <v-layout wrap>
                            <v-flex lg12>
                              <v-text-field
                                mask="####-####-####-####"
                                v-model="data.card_no"
                                label="Card No."
                                required
                                counter="16"
                                maxlength="16"
                                v-on:keypress="isNumber($event)"
                                :rules="[rules.required, rules.counter]"
                              ></v-text-field>

                              <v-text-field
                                v-model="data.value"
                                label="Value"
                                required
                                @keypress="isNumber($event)"
                                :rules="[rules.required, rules.limitValue]"
                              ></v-text-field>

                              <v-text-field
                                v-model="data.csr_ticket_no"
                                label="CSR Ticket No."
                                requiredsaveDialo
                                :rules="[rules.required]"
                              ></v-text-field>

                              <!-- Date from -->
                              <v-menu
                                ref="dateFromMenu"
                                :close-on-content-click="false"
                                v-model="dateFromMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="dateFrom"
                                  label="Date From"
                                  prepend-inner-icon="event"
                                  readonly
                                ></v-text-field>
                              </v-menu>
                              <!-- date from end -->

                              <!-- date to -->
                              <v-menu
                                ref="nextWeekMenu"
                                :close-on-content-click="false"
                                v-model="nextWeekMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="nextWeek"
                                  label="Date To"
                                  prepend-inner-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker
                                  ref="picker"
                                  v-model="nextWeek"
                                  :min="nextWeekMin"
                                  @input="nextWeekMenu = false"
                                ></v-date-picker>
                              </v-menu>
                              <!-- date to end... -->
                               
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-form>
                    </jti-expansion-panel>
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'add' && dialogTitle === 'cashback'
                  ? saveAddDialogCashback()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>

          <cancel-dialog
            :title="title"
            :type="cancelType"
            :cancelDialog="cancelDialog"
            @saveCancelDialog="saveCancelDialog"
            @closeCancelDialog="closeCancelDialog"
            :loading="confirmLoading"
          ></cancel-dialog>

          <remarks-dialog
            :title="title"
            :type="cancelType"
            ref="remark"
            :remarksDialog="remarksDialog"
            @saveCancelDialog="saveCancelDialog"
            @closeCancelDialog="closeCancelDialog"
            :loading="confirmLoading"
          ></remarks-dialog>

          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">
                    {{
                      openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterStatus"
                :items="filterStats"
                label="By Status"
                solo
                clearable
              ></v-select>
            </v-flex>

            <v-flex md4>
              <v-select
                v-model="filterSms"
                :items="filterSMS"
                label="By SMS"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{ props.item.card_no }}
              </td>
              <td class="text-xs-center">{{ props.item.verification_code }}</td>
              <td class="text-xs-center no-wrap">
                {{ $dateFormat(props.item.created_at, "YYYY-MM-DD") }}
              </td>
              <td class="text-xs-center no-wrap">
                {{ $dateFormat(props.item.created_at, "HH:mm") }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.date_start === "Invalid date" ||
                  props.item.date_start === null ||
                  props.item.date_start === undefined ||
                  props.item.date_start === ""
                    ? "--"
                    : $dateFormat(props.item.date_start, "YYYY-MM-DD")
                }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.date_start === "Invalid date" ||
                  props.item.date_start === null ||
                  props.item.date_start === undefined ||
                  props.item.date_start === ""
                    ? "--"
                    : $dateFormat(props.item.date_start, "HH:mm")
                }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.date_end === "Invalid date" ||
                  props.item.date_end === null ||
                  props.item.date_end === undefined ||
                  props.item.date_end === ""
                    ? "--"
                    : $dateFormat(props.item.date_end, "YYYY-MM-DD")
                }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.date_end === "Invalid date" ||
                  props.item.date_end === null ||
                  props.item.date_end === undefined ||
                  props.item.date_end === ""
                    ? "--"
                    : $dateFormat(props.item.date_end, "HH:mm")
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.date_redeemed === "Invalid date" ||
                  props.item.date_redeemed === null ||
                  props.item.date_redeemed === undefined ||
                  props.item.date_redeemed === ""
                    ? "--"
                    : $dateFormat(props.item.date_redeemed, "YYYY-MM-DD")
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.date_redeemed === "Invalid date" ||
                  props.item.date_redeemed === null ||
                  props.item.date_redeemed === undefined ||
                  props.item.date_redeemed === ""
                    ? "--"
                    : $dateFormat(props.item.date_redeemed, "HH:mm")
                }}
              </td>
              <td class="text-xs-center text-no-wrap">
                {{
                  props.item.created_by !== null
                    ? props.item.created_by.first_name.toUpperCase() +
                      " " +
                      props.item.created_by.last_name.toUpperCase()
                    : "--"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.status === 1
                    ? "REDEEMED"
                    : props.item.status === 2
                    ? "LAPSE"
                    : props.item.status === 3
                    ? "CANCELED"
                    : "PENDING"
                }}
              </td>
              <td class="text-xs-center">
                <v-icon
                  :color="
                    props.item.status === 1
                      ? props.item.sms_status === 1
                        ? 'blue'
                        : props.item.sms_status === 0
                        ? 'red'
                        : 'grey'
                      : 'grey'
                  "
                  >{{
                    props.item.status === 1
                      ? props.item.sms_status === 1
                        ? "done"
                        : props.item.sms_status === 0
                        ? "clear"
                        : "remove"
                      : "remove"
                  }}</v-icon
                >
              </td>

              <td class="text-xs-center">
                <v-icon
                  :color="
                    props.item.card_transaction_sync_id !== null
                      ? 'blue'
                      : 'red'
                  "
                  >{{
                    props.item.card_transaction_sync_id !== null
                      ? "done"
                      : "clear"
                  }}</v-icon
                >
              </td>
              <td class="text-xs-right">
                {{ $amountInPeso(props.item.value) }}
              </td>
              <!-- <td class="text-xs-left">{{ props.item.remarks ? props.item.remarks : "--" }}</td> -->
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <cancel-button
                  :disabledButton="props.item.status === 0 ? false : true"
                  @cancel="
                    props.item.status === 0 ? openCancelDialog(props.item) : ''
                  "
                ></cancel-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/CashbackDetailsContainer.vue";
import UploadCsv from "@/components/UploadCSV";
import OfficialMap from "@/components/OfficialMap";
import RemarksDialog from "@/components/dialog/RemarksDialog.vue";
import XLSX from "xlsx";
var now = new Date();
var jsonexport = require("jsonexport");
var week = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);

export default {
  components: {
    DetailsContainer,
    UploadCsv,
    OfficialMap,
    RemarksDialog,
  },
  data() {
    return {
      dialogue: false,
      heightMap: 0,
      center: { lat: 14.4793, lng: 121.0198 },
      openPanel: [true],
      cancelDialog: false,
      cancelType: "",
      remarksDialog: false,
      confirmLoading: false,
      dialogLoading: false,
      filterStats: [
        {
          text: "PENDING",
          value: 0,
        },
        {
          text: "REDEEMED",
          value: 1,
        },
        {
          text: "LAPSE",
          value: 2,
        },
        {
          text: "CANCELED",
          value: 3,
        },
      ],
      filterStatus: "",
      filterSMS: [
        {
          text: "FAILED",
          value: 0,
        },
        {
          text: "SUCCESS",
          value: 1,
        },
      ],
      filterSms: "",
      openFilter: false,
      items: [],
      title: "Cashback",
      headers: [
          {
            text: "#",
            align: "center",
            sortable: false
          },
          {
            text: "Card No.",
            align: "center",
            sortable: false
          },
          {
            text: "Verification Code",
            align: "center",
            sortable: false
          },
          {
            text: "Date Created",
            align: "center",
            sortable: false
          },
          {
            text: "Time Created",
            align: "center",
            sortable: false
          },
          {
            text: "Date Start",
            align: "center",
            sortable: false
          },
          {
            text: "Time Start",
            align: "center",
            sortable: false
          },
          {
            text: "Date End",
            align: "center",
            sortable: false
          },
          {
            text: "Time End",
            align: "center",
            sortable: false
          },
          {
            text: "Date Redeemed",
            align: "center",
            sortable: false
          },
          {
            text: "Time Redeemed",
            align: "center",
            sortable: false
          },
          {
            text: "Created By",
            align: "center",
            sortable: false
          },
          {
            text: "Status",
            align: "center",
            sortable: false
          },
          {
            text: "Sms",
            align: "center",
            sortable: false
          },
          {
            text: "Sync",
            align: "center",
            sortable: false
          },
  
          {
            text: "Value",
            align: "center",
            sortable: false
          },
          {
            text: "Action",
            align: "center",
            sortable: false
          }
        ],
      data: {
        card_no: "",
      },
      viewData: {},
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length >= 16 || "Must be 16 digits",
        limitValue: (value) => {
          if (value > 5000) {
            return "Maximum of 5000 only";
          } else if (!value) {
            return false;
          } else {
            return true;
          }
        },
      },
      queryParams: {
        search: null,
        limit: 10,
        offset: 0,
      },
      totalItems: 0,
      dialogLoading: false,
      dialogType: "",
      dialogTitle: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      valid: true,
      dateFromMenu: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateToMenu: false,
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      nextWeekMenu: false,
      nextWeek: this.$dateFormat(week, "YYYY-MM-DD"),
      nextWeekMin: this.$dateFormat(week, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      uploadLoading: false,
      valid: true,

      uploadItems: [],
    };
  },
  created: async function() {
    // await this.getData();
    await this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  watch: {
    filterStatus: async function() {
      if (
        this.filterStatus !== null &&
        this.filterStatus !== undefined &&
        this.filterStatus !== "".type
      ) {
        this.queryParams.offset = 0;
        this.queryParams.status = this.filterStatus;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.status = null;
        this.getData();
      }
    },
    filterSms: async function() {
      if (
        this.filterSms !== null &&
        this.filterSms !== undefined &&
        this.filterSms !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sms_status = this.filterSms;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sms_status = null;
        this.getData();
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getCashback(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }

        if (this.totalItems <= this.queryParams.limit) {
          this.disabledLimit = true;
        } else {
          this.disabledLimit = false;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openAddDialog(type) {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.dialogTitle = type;

      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.nextWeek = this.$dateFormat(week, "YYYY-MM-DD");

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.dialogTitle = this.title;

      this.viewData = await this.setData(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async saveCancelDialog() {
      this.confirmLoading = true;
      console.log(this.$refs.remark.remarks);
      try {
        const body = {
          id: this.viewData.id,
          remarks: this.$refs.remark.remarks,
        };
        const response = await Services.cancelCashback(body);

        if (response.status === 200 || response.status === 201) {
          this.closeCancelDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Cashback has been canceled!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeCancelDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.confirmLoading = false;
    },
    async openCancelDialog(data) {
      this.remarksDialog = true;
      this.viewData.id = data.id;
    },
    async closeCancelDialog() {
      this.remarksDialog = false;
    },
    async setData(items) {
      let data = {
        card_no: items.card_no,
        verification_code: items.verification_code,
        date_created: this.$dateFormat(items.created_at, "YYYY-MM-DD"),
        time_created: this.$dateFormat(items.created_at, "HH:mm"),
        date_start:
          items.date_start === "Invalid date" ||
          items.date_start === null ||
          items.date_start === undefined ||
          items.date_start === ""
            ? "--"
            : this.$dateFormat(items.date_start, "YYYY-MM-DD"),
        time_start:
          items.date_start === "Invalid date" ||
          items.date_start === null ||
          items.date_start === undefined ||
          items.date_start === ""
            ? "--"
            : this.$dateFormat(items.date_start, "HH:mm"),
        date_end:
          items.date_end === "Invalid date" ||
          items.date_end === null ||
          items.date_end === undefined ||
          items.date_end === ""
            ? "--"
            : this.$dateFormat(items.date_end, "YYYY-MM-DD"),
        time_end:
          items.date_end === "Invalid date" ||
          items.date_end === null ||
          items.date_end === undefined ||
          items.date_end === ""
            ? "--"
            : this.$dateFormat(items.date_end, "HH:mm"),
        date_redeemed:
          items.date_redeemed === "Invalid date" ||
          items.date_redeemed === null ||
          items.date_redeemed === undefined ||
          items.date_redeemed === ""
            ? "--"
            : this.$dateFormat(items.date_redeemed, "YYYY-MM-DD"),
        time_redeemed:
          items.date_redeemed === "Invalid date" ||
          items.date_redeemed === null ||
          items.date_redeemed === undefined ||
          items.date_redeemed === ""
            ? "--"
            : this.$dateFormat(items.date_redeemed, "HH:mm"),
        status: items.status === 1 ? "REDEEMED" : "PENDING",
        type: items.type === 4 ? "CASHBACK" : "",
        value: this.$amountInPeso(items.value),
        remarks: items.remarks,
        cancel_remarks: items.cancel_remarks ? items.cancel_remarks.toUpperCase() : null,
        card_transaction_sync:
          items.card_transaction_sync_id === null ||
          items.card_transaction_sync === null
            ? null
            : items.card_transaction_sync,
      };

      return data;
    },
    closeDialog() {
      if (this.dialogLoading === false && this.dialogTitle === "cashback") {
        this.$refs.form.reset();
      }

      this.e1 = 0;
      this.viewData = {};
      this.closeConfirmDialog();
      this.dialogTitle = "";
      this.dialogType = "";
      this.dialogStatus = false;
      this.uploadItems = [];
    },
    async saveDialog() {
      let newItems = [];

      newItems = this.uploadItems;

      for (let index = 0; index < newItems.length; index++) {
        const data = newItems[index];

        if ((await data.card_no.length) != 16) {
          this.$infoBar({
            type: "error",
            text: "Error on Card No(s)",
          });
        } else {
          if (this.$refs.formPromo.validate()) {
            this.openConfirmDialog = true;
          }
        }
      }

      if (this.dialogTitle === "cashback") {
        if (this.$refs.form.validate()) {
          this.openConfirmDialog = true;
        }
      }
    },
    async saveAddDialogCashback() {
      this.confirmLoading = true;

      const body = {
        card_no: this.data.card_no,
        value: parseFloat(this.data.value),
        date_start: this.dateFrom,
        date_end: this.nextWeek,
        csr_ticket_no: this.data.csr_ticket_no,
      };

      try {
        const response = await Services.addCashback(body);

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Cashback has been added!",
          });
        } else {
          this.closeConfirmDialog();
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    titleCase(str) {
      let splitStr = str.toLowerCase().split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },
    openFilterExpansion() {
      this.openFilter = !this.openFilter;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    refreshData() {
      this.$refs.searchRef.clear();
      this.filterStatus = null;
      this.filterSms = null;
      this.getData();
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;

      // Block decimal points (.) and other non-numeric characters except for 0-9
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    async downloadExcel() {
      let dataToDownload = [];
      let header = [];
      this.items2 = [];

      const response2 = (
        await Services.getCashback({
          offset: 0,
          status: this.filterStatus,
          type: this.filterType,
          sms_status: this.filterSms,
        })
      ).data;

      this.items2 = response2.data;

      for (let i = 0; i < this.headers.length - 1; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();

      dataToDownload.push(header);

      header.push("REMARKS");

      this.items2.forEach((item) => {
        let theItem = [];

        theItem.push(item.card_no);
        theItem.push("" + item.verification_code);
        theItem.push(this.$dateFormat(item.created_at, "YYYY-MM-DD"));
        theItem.push(this.$dateFormat(item.created_at, "HH:mm"));
        theItem.push(
          item.date_start === "Invalid date" ||
            item.date_start === null ||
            item.date_start === undefined ||
            item.date_start === ""
            ? "--"
            : this.$dateFormat(item.date_start, "YYYY-MM-DD")
        );
        theItem.push(
          item.date_start === "Invalid date" ||
            item.date_start === null ||
            item.date_start === undefined ||
            item.date_start === ""
            ? "--"
            : this.$dateFormat(item.date_start, "HH:mm")
        );
        theItem.push(
          item.date_end === "Invalid date" ||
            item.date_end === null ||
            item.date_end === undefined ||
            item.date_end === ""
            ? "--"
            : this.$dateFormat(item.date_end, "YYYY-MM-DD")
        );
        theItem.push(
          item.date_end === "Invalid date" ||
            item.date_end === null ||
            item.date_end === undefined ||
            item.date_end === ""
            ? "--"
            : this.$dateFormat(item.date_end, "HH:mm")
        );
        theItem.push(
          item.date_redeemed === "Invalid date" ||
            item.date_redeemed === null ||
            item.date_redeemed === undefined ||
            item.date_redeemed === ""
            ? "--"
            : this.$dateFormat(item.date_redeemed, "YYYY-MM-DD")
        );
        theItem.push(
          item.date_redeemed === "Invalid date" ||
            item.date_redeemed === null ||
            item.date_redeemed === undefined ||
            item.date_redeemed === ""
            ? "--"
            : this.$dateFormat(item.date_redeemed, "HH:mm")
        );
        theItem.push(
          item.created_by !== null
            ? item.created_by.first_name.toUpperCase() + " " + item.created_by.last_name.toUpperCase()
            : "--"
        );
        theItem.push(
          item.status === 1
            ? "REDEEMED"
            : item.status === 2
            ? "LAPSE"
            : item.status === 3
            ? "CANCELED"
            : "PENDING"
        );
        theItem.push(
          item.status === 1
            ? item.sms_status === 1
              ? "SUCCESS"
              : item.sms_status === 0
              ? "FAILED"
              : "--"
            : "--"
        );
        theItem.push(
          item.card_transaction_sync_id === null
            ? "NOT YET SYNC"
            : "ALREADY BEEN SYNC"
        );
        theItem.push(this.$amountInPeso(item.value));
        theItem.push(item.remarks ? item.remarks.toUpperCase() : "--");

        dataToDownload.push(theItem);
      });

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped></style>
